declare module 'axios' {
  export interface AxiosRequestConfig {
    toastError?: boolean;
  }
}

export const handleErrorInterceptor = (error: Error) => {
  return Promise.reject(error);
};
